//Bundle-time shim: esbuild resolves `require('jquery')` here (see gulpfile.js alias).
//Vendor UMD wrappers (e.g. slick.js) take the CommonJS branch under esbuild and would
//otherwise inline a second jQuery from node_modules, registering their plugin on that
//private copy instead of the page's global one.
module.exports = window.jQuery;
